export default __webpack_public_path__ + "static/media/back_grapes_001.20164f54.png";